import type { RoleOption } from './types.js';

/** Roles come from config/portal.json; a person may hold several. */
export function RolePicker({
  roles,
  value,
  onChange,
}: {
  roles: RoleOption[];
  value: string[];
  onChange(value: string[]): void;
}) {
  return (
    <fieldset>
      <legend>
        Roles <span className="req">*</span>
      </legend>
      <div className="chips">
        {roles.map((role) => (
          <label key={role.key} className="chip">
            <input
              type="checkbox"
              checked={value.includes(role.key)}
              onChange={(e) =>
                onChange(
                  e.target.checked ? [...value, role.key] : value.filter((k) => k !== role.key),
                )
              }
            />
            {role.label}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
